import { Route } from 'react-router'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { HistoryPage } from 'pages/contacts/pages/history/ui/historyPage'
import { HistoryLayout } from 'pages/contacts/pages/history/layout/HistoryLayout'

export const HistoryRouter = () => {
  return (
    <RoutesWithNotFound>
      <Route element={<HistoryLayout />}>
        <Route path={'/'} element={<HistoryPage />} />
      </Route>
    </RoutesWithNotFound>
  )
}
